<template lang="pug">
  md-app(id="app"  md-mode="fixed")
      md-app-toolbar.md-accent
        a(href="/")
          img(src="/static/img/logo.png" style="height:64px")
        // md-button.md-icon-button.md-dense(@click="$router.push({path:'/'})")
        span.md-small-hide(v-if="toolbar" style="flex:1;text-align:right;margin-right:2em")
        span(v-else style="flex:1")
        md-button.md-dense(v-if="toolbar" @click.native="go('step/data')") Start
        md-button.md-dense(v-if="toolbar" @click.native="go('help')") Help
        language-menu
      md-app-content
        router-view
        vue-cookie-accept-decline(:debug="false" :position="'bottom'" :disableDecline="true" :transitionName="'slideFromBottom'" @clickedAccept="cookieClickedAccept")
          div(slot="message")
              | We use cookies to ensure you get the best experience on our website. 
              router-link(:to="'/'+language+'/privacy-policy'") Learn More...
          div(slot="acceptContent")
              | Got It!
        md-snackbar(:md-duration="duration" :md-active.sync="snack" md-position="left")
          span(v-if="error.label!==undefined") {{$t(error.label)}}
          span(v-else) {{error.message }}
          md-button.md-primary(@click.native="clearSnack") {{$t('label.close')}}
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import LanguageMenu from '@/components/LanguageMenu'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import { CLEAR_ERROR } from '@/constants/store'
export default {
  name: 'MyCavalor',
  data () {
    return {
      duration: 4000,
      snack: false
    }
  },
  watch: {
    error () {
      // close current snack if open
      this.snack = false
      if (Object.keys(this.error).length !== 0) {
        this.snack = true
      }
    }
  },
  computed: {
    ...mapState([
      'languages',
      'language',
      'toolbar',
      'error'
    ]),
    ...mapGetters([
      'languageLabel'
    ])
  },
  methods: {
    go (id) {
      var to = '/' + this.language + '/' + id
      this.$router.push({path: to})
    },
    cookieClickedAccept () {
      // console.log('accepted coookies')
    },
    clearSnack () {
      this.$store.commit(CLEAR_ERROR)
      this.snack = false
    }
  },
  components: { LanguageMenu, VueCookieAcceptDecline }
}
</script>

<style lang="scss" >
@mixin responsive($properties, $default-value, $responsive-values){

    // No named breakpoints by default
    $named-breakpoints: () !default;
  
    // Apply default property values
    @each $property in $properties{
      #{$property}: #{$default-value};
    }
    
    @each $breakpoint, $value in $responsive-values{
  
      // Get named breakpoint values
      @if type-of($breakpoint) == string{
        @if(map-has-key($named-breakpoints, $breakpoint)){
          $breakpoint: map-get($named-breakpoints, $breakpoint);
        }
        @else{
          @warn "Couldn't find named breakpoint: " + $breakpoint;
        }
      }
  
      // Use Breakpoint if it exists
      @if mixin-exists("breakpoint"){
        // Apply at breakpoint
        @include breakpoint($breakpoint) {
          @each $property in $properties{
            #{$property}: #{$value};
          }
        }
      }
      // Fallback to min-width media queries
      @else{
        @media screen and (min-width: $breakpoint) {
          @each $property in $properties{
            #{$property}: #{$value};
          }
        }
      }
  
    }
  
  }

@media (max-width: 320px) {

      .md-button.md-dense {
        min-width: 48px;
        height: 24px;
        font-size: 13px !important;
      }
}
@media (max-width: 400px) {

      .md-layout {
        font-size: 12px;
        h1 {
          font-size: 18px;
          line-height: 25px;
        }
        .md-button {
          font-size: 12px;
        }
        .md-checkbox-label {
          font-size: 13px;
        }

      }
}
@media (max-width: 700px) {
    html, body{

        font-size: 12px;
        line-height: 14px;
    }
}

html{
  height: 100vh;
}
body {
    display: flex;
}

.app {
  font-family: "OpenSans", Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  min-width: 69.28571rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

}
.md-app {
  max-height: 100vh;
}
.md-app .md-app-content {
  // background-color:#F0F3F6;
  padding:0px;
  width: 100vw;
}
.md-content.md-theme-default {
  background-color: transparent
}

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "OpenSans";
  font-style: normal;
  font-weight: 400;
  src: url("/static/fonts/OpenSans-Regular.ttf") format("truetype"); }

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "OpenSans";
  font-style: italic;
  font-weight: 400;
  src: url("/static/fonts/OpenSans-Italic.ttf") format("truetype"); }

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "OpenSans";
  font-style: normal;
  font-weight: 600;
  src: url("/static/fonts/OpenSans-SemiBold.ttf") format("truetype"); }

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "OpenSans";
  font-style: italic;
  font-weight: 600;
  src: url("/static/fonts/OpenSans-SemiBoldItalic.ttf") format("truetype"); }

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  src: url("/static/fonts/Montserrat-Regular.ttf") format("truetype"); }

/* stylelint-disable-next-line function-url-quotes */
@font-face {
  font-family: "Montserrat";
  font-style: italic;
  font-weight: 400;
  src: url("/static/fonts/Montserrat-Italic.ttf") format("truetype"); }

h1 {
  font-family: "Montserrat";
  font-size: 1.42857rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

h2 {
  font-family: "Montserrat";
  font-size: 1.28571rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

h3 {
  font-family: "Montserrat";
  font-size: 1.14286rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

h4 {
  font-family: "Montserrat";
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

h5 {
  font-family: "Montserrat";
  font-size: 0.85714rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

h6 {
  font-family: "Montserrat";
  font-size: 0.71429rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.03571rem; }

.kv {
  border-left: 3px solid rgba(74, 128, 255, 1);
  height: 100%;
  left: 0%;
  top: 0;
}
.rv {
  border-left: 3px solid rgba(0, 255, 0, 1);
  height: 100%;
  left: 0%;
  top: 0;
}
.sup {
  border-left: 3px solid rgba(255, 152, 0, 1);
  height: 100%;
  left: 0%;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue